import React from 'react';
import Table from '../../component/table/table'
import {BASE_END_POINT} from '../../urls'
import axios from 'axios'
import AddIcon from '@material-ui/icons/Add';
import Fab from '@material-ui/core/Fab';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Pagination from '@material-ui/lab/Pagination';
import { MDBContainer,  MDBRow, MDBCol} from "mdbreact";
import './clients.css'
import {message,TreeSelect} from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import {NavLink, withRouter,Redirect} from 'react-router-dom'
import {ChangeLanguage} from '../../redux/actions/LanguageAction'
import { CSVLink } from "react-csv";
//import 'moment/locale/ar';
import {SearchOutlined} from '@ant-design/icons';
import moment from 'moment'

const { TreeNode } = TreeSelect;
let headers = [
  { label: "#", key: "id" },
  { label: "ClientName", key: "clientName" },
  { label: "ClientPhone", key: "clientPhone" },
  { label: "ClientCountry", key: "clientCountry" },
  { label: "SalesName", key: "salesName" },
  { label: "SalesPhone", key: "salesPhone" },
  { label: "SalesCountry", key: "salesCountry" },
  { label: "Location", key: "location" },
  { label: "Category", key: "category" },

  { label: "Date", key: "date" },
];
 
let csvData = [
  
];
class clients extends React.Component {
  
  state={
    clients:[],
    clients2:[],
    categories:[],
    locations:[],
    csvData:[],
    loading:true,
    refresh:false,
    page:1,
    pages:1,
    collapsed: false,
    user:this.props.location.state?this.props.location.state.owner:null,
    search:null,
    category:null,
    location:null,
    filterType:{},
    status:null,
    clientsFile:null,
    value:'',
  }

  constructor(props){
    super(props)
    this.getClientsWithoutPagenation()
    window.scrollTo(0,0)
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }

  componentDidMount(){
    this.getClients(1)
    this.getCategory()
    this.getLocation()
    if(this.props.isRTL){
      allStrings.setLanguage('ar')
    }else{
      allStrings.setLanguage('en')
    }
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
    .then(response=>{
      console.log(response.data)
      this.setState({categories:response.data.data})
    })
    .catch(error=>{
      console.log("ALL categories ERROR")
      console.log(error.response)
    })
  }
  getLocation = () => {
    axios.get(`${BASE_END_POINT}location/withoutPagenation/get`)
    .then(response=>{
      console.log(response.data)
      this.setState({locations:response.data.data})
    })
    .catch(error=>{
      console.log("ALL locations ERROR")
      console.log(error.response)
    })
  }

  getClients = (page,rest) =>{
    this.setState({loading:true})
    let url = `${BASE_END_POINT}clients?page=${page}`
    let {location,search,category,user} = this.state
    if(user !== null){
      let str = '&user='+ user
      url += str
    }
    if(category !== null){
      let str = '&category='+ category
      url += str
    }
    if(location !== null){
      let str = '&location='+ location
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(rest) url = `${BASE_END_POINT}clients?page=${page}`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("clients   ",response.data)
      var data = response.data.data.map(item=>[
        item.id,
        item.clientName?item.clientName :'',
        item.clientPhone?item.clientPhone :'',
        item.salesName?item.salesName :'',
        item.salesPhone?item.salesPhone :'',
        // item.location?item.location.map((val, index) =>
        // val.name +  " - "
        // ):"",
        // item.category?item.category.map((val, index) =>
        // val.categoryName +  " - "
        // ):"",
        "action"])
      console.log("DATA   ",data)
      this.setState({
        loading:false,
        refresh:false,
        clients:response.data.data,
        clients2:data,
        page:response.data.page,
        pages:response.data.pageCount,
      })
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
      this.setState({loading:false,})
    })
  }
  getClientsWithoutPagenation = (rest) =>{
    let url = `${BASE_END_POINT}clients/withoutPagenation/get?all=true`
    let {location,search,category,user} = this.state
    if(location !== null){
      let str = '&location='+ location
      url += str
    }
    if(user !== null){
      let str = '&user='+ user
      url += str
    }
    if(category !== null){
      let str = '&category='+ category
      url += str
    }
    if(search !== null){
      let str = '&search='+ search
      url += str
    }
    if(rest) url = `${BASE_END_POINT}clients/withoutPagenation/get&all=true`
    axios.get(url,{
      headers:{
        'Authorization':`Bearer ${this.props.currentUser.token}`,
        'Accept-Language':this.props.isRTL?'ar':'en'
      }
    })
    .then(response=>{
      console.log("clients   ",response.data)
        csvData= response.data.data.map(item => {
          return {
            ...{id:item.id},
            ...{clientName:item.clientName?item.clientName:''},
            ...{clientPhone:item.clientPhone?item.clientPhone:''},
            ...{clientCountry:item.clientCountry?item.clientCountry.name:''},
            ...{salesName:item.salesName?item.salesName:''},
            ...{salesPhone:item.salesPhone?item.salesPhone:''},
            ...{salesCountry:item.salesCountry?item.salesCountry.name:''},
            ...{location:item.location?item.location.map((val, index) =>
              val.name +  " - "
              ):""},
            ...{category:item.category?item.category.map((val, index) =>
              val.categoryName + " - "
              ):""},
            ...{date:moment(item.createdAt).format('lll')},
          };
        });
        console.log(csvData)
        this.setState({csvData:csvData})
      
    })
    .catch(error=>{
      console.log("error   ",error.response)
      console.log("error2   ",error)
    })
  }
  delete = (id) => {
    console.log("ID   ",id)
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}clients/${id}`,{
     headers: {
       'Content-Type': 'application/json',
       'Authorization':`Bearer ${this.props.currentUser.token}`,
       'Accept-Language':this.props.isRTL?'ar':'en'
     },
    })
    .then(response=>{
      console.log("Row DELETED")
      l.then(() => message.success(allStrings.done, 2.5) )
      this.getClients(this.state.page)
    })
    .catch(error=>{
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
    })
 }
 acceptAll = () => {
  let l = message.loading('Wait..', 2.5)
  axios.put(`${BASE_END_POINT}clients/accept/AllClient`,{},{
   headers: {
     'Content-Type': 'application/json',
     'Authorization':`Bearer ${this.props.currentUser.token}`,
     'Accept-Language':this.props.isRTL?'ar':'en'
   },
  })
  .then(response=>{
    l.then(() => message.success(allStrings.done, 2.5) )
    this.getClients(this.state.page)
  })
  .catch(error=>{
      console.log(error.response)
      l.then(() => message.error(allStrings.error, 2.5))
  })
}
acceptAllButton = () =>(
  <div style={{width:'100%'}} onClick={()=>this.acceptAll()}>
      <Fab
        style={{background:'#E6B659',float:'left',margin:'50px 30px'}}
        variant="extended"
        size="medium"
        color="primary"
        aria-label="add"
      >
        <AddIcon />{allStrings.acceptAll}
      </Fab>
  </div>
)

  addNewRecordButton = () =>(
    <div style={{width:'100%'}}>
      <NavLink to="addClient">
        <Fab
          style={{background:'#E6B659',float:'left',margin:'50px 30px'}}
          variant="extended"
          size="medium"
          color="primary"
          aria-label="add"
        >
          <AddIcon />{allStrings.addNewRecored}
        </Fab>
      </NavLink>
      
    </div>
  )

  paginationButtons = () =>(
    <CardActions style={{dACCEPTEDlay: 'inline-flex'}}>
        <Button 
        onClick={()=>{
          if(this.state.page!==1){
            this.getClients(1)
            this.setState({page:1})
          }
        }}
        className="pagenation" >{allStrings.first}</Button>

        <Button 
        onClick={()=>{
         if(this.state.page>1){
            this.getClients(this.state.page-1)
            this.setState({page:this.state.page-1})
         }
        }}
        className="pagenation">{allStrings.prev}</Button>
        
        <Pagination
        onChange={(event,page)=>{
        console.log("page   ",page)
        if(page!==this.state.page){
          this.getClients(page)
          this.setState({page:page})
        }
        
        }} 
        defaultPage={1} page={this.state.page} count={this.state.pages} 
        style={{color:`#E6B659 !important`}} />
        
        <Button 
        onClick={()=>{
          if(this.state.page<this.state.pages){
            this.getClients(this.state.page+1)
            this.setState({page:this.state.page+1})
          }
        }}
        className="pagenation">{allStrings.next}</Button>

        <Button 
         onClick={()=>{
          if(this.state.page!==this.state.pages){
            this.getClients(this.state.pages)
            this.setState({page:this.state.pages})
          }
        }}
        className="pagenation">{allStrings.last}</Button>

    </CardActions>
  )

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  render() {
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('CLIENTS')) return <Redirect to='/Home' />

    return (
        
      <MDBContainer> 
      <MDBRow>
        <MDBCol md="12">
          <div className="screenTable">
          
          <Table
            enableEdit = {false}
            title={allStrings.clients}
            icon='contact_phone'
            
            settings = {
              <div>
                <i class="fab fa-searchengin searchIcon" onClick={()=>this.setState({showFilter:!this.state.showFilter})}></i>
                <span 
                style={{position: 'relative',padding: '4px',color: '#659FF1',fontSize: '25px',borderRadius:'50%',top:'4px',cursor: 'pointer'}}
                onClick={() => {this.setState({search:null,status:null});this.getClients(1,true);this.getClientsWithoutPagenation(true)}}
                class="material-icons">
                  replay
                </span>
                <CSVLink 
                  data={this.state.csvData} 
                  headers={headers} 
                  filename={"clients.csv"}
                  style={{padding: '10px',position: 'relative',top: '-5px'}}
                  >
                  <img crossorigin="anonymous"alt="" src={require('../../assets/images/export-csv.png')} width="28"></img>
                </CSVLink>
              </div>
              
            }
            filter ={
              <div>
                <div className={this.state.showFilter?'showClass160':'hideClass'}>
                  <MDBRow>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <div class="md-form">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.Search}</label>
                      <input style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center',fontWeight:'300'}} type="text" id="form605"  class="form-control"
                        placeholder={allStrings.Search}
                        onChange={(e)=>{
                          this.setState({search:e.target.value})
                        }}  
                      />
                      </div>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.location}</label>

                      <TreeSelect virtual={false}
                          showSearch={false}
                          style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                          treeCheckable = {false}         
                          treeNodeFilterProp="title"                      
                          dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                          placeholder={allStrings.location}
                          value={this.state.location}
                          onChange={(value) => {
                          console.log(value)
                          this.setState({location:value});
                          }} 
                      
                      >
                          {this.state.locations.map(val=>(
                              <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                          ))}
                      </TreeSelect>
                    </MDBCol>
                    <MDBCol xl="4" lg="4" md="4" sm="12">
                        <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.category}</label>
                        <TreeSelect virtual={false}
                            showSearch={false}
                            style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                            treeCheckable = {false}         
                            treeNodeFilterProp="title"                      
                            dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                            placeholder={allStrings.category}
                            value={this.state.category}
                            onChange={(value) => {
                            console.log(value)
                            this.setState({category:value});
                            }} 
                        
                        >
                            {this.state.categories.map(val=>(
                                <TreeNode value={val.id} title={this.props.isRTL?val.categoryName_ar:val.categoryName_en} key={val.id} />
                            ))}
                        </TreeSelect>
                    </MDBCol>
                    
                  </MDBRow>
                  <MDBRow>
                  <Button style={{background: '#E6B659',color: '#fff',width: '100%',margin: '32px auto'}} 
                        onClick={()=>{this.getClients(1);this.getClientsWithoutPagenation()}}><SearchOutlined /> {allStrings.Search}</Button>
                    
                  </MDBRow>
                  
                </div>
              </div>
            }
            data={this.state.clients}
            data2={this.state.clients2}
            tableColumns={["#",allStrings.clientName,allStrings.clientPhone,allStrings.salesName,allStrings.salesPhone,allStrings.action]}loading={this.state.loading}
            deleteUser={(id)=>{this.delete(id)}}
            path='/ClientInfo'
            actionIndex={8}
            />
            {this.paginationButtons()}
            {this.acceptAllButton()}
              
            </div>
        </MDBCol>
      </MDBRow>
    </MDBContainer>
    
    );
  }

}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDACCEPTEDatchToProps = {
  ChangeLanguage
}

export default  withRouter(
  connect(mapToStateProps,mapDACCEPTEDatchToProps)(clients)
);

